import axios from "axios"

axios.defaults.baseURL = (import.meta.env.VITE_API_ENDPOINT ?? 'https://localhost:7243') + '/api'

axios.interceptors.response.use((response) => response, (error) => {
  console.log('From interceptor:', error)

  return Promise.reject(error)
})

export async function checkHealth(): Promise<boolean> {
  try {
    const url = (import.meta.env.VITE_API_ENDPOINT ?? 'https://localhost:7243') + '/healthz/liveness'
    const response = await axios.get(url)

    console.log(response)
    return true
  } catch (error) {
    return false
  }
}